import React, { useEffect, useState } from 'react'
//components
import EditableTable from '../../../components/ui/editableTable/EditableTable'
//config
import { JobLinksSchema } from '../tableConfig/adminSchemas'
//api
import { getAllJobLinksAPI, updateJobLinkIsActiveAPI } from '../../../services/jobPermissionsAPI'
//hooks
import { useLoading } from '../../../contexts/LoadingContext'
import { useError } from '../../../contexts/ErrorContext'

/**
 * Table displays all job links and whether they are currently active
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Admin Dashboard
 */
export const JobLinks = () => {
    const [jobLinks, setJobLinks] = useState([])

    const {showLoading, hideLoading} = useLoading()
    const {showError} = useError()

    //fetch links
    const fetchJobLinks = async() => {
        showLoading("Getting job links...")

        const response = await getAllJobLinksAPI();

        if (!response.success) {
            hideLoading()

            showError(`Error getting job links: ${response.message}`)
            
            return
        }
        
        //sort based on numerical part of job name string
        //so we can see links for the same jobs grouped together
        const sortedLinks = response.data.sort((a, b) => {
            const regex = /Job_(\d+)\s*_/; // allow spaces between number and underscore, in case there is a space in the job number
            
            const numA = parseInt(a.name.match(regex)[1], 10);
            const numB = parseInt(b.name.match(regex)[1], 10);
            
            return numA - numB;
        });

        setJobLinks(sortedLinks)

        hideLoading()
    }

    const handleActivateJobLink = async(rowIndex, e) => {

        const LinkID = jobLinks[rowIndex].LinkID
        const JobID = jobLinks[rowIndex].JobID
        const IsActive = e

        showLoading("Updating job links...")

        const response = await updateJobLinkIsActiveAPI(JobID, LinkID, IsActive);

        if (!response.success) {
            hideLoading()

            showError(`Error updating job link: ${response.message}`)
            
            return
        }
                

        setJobLinks(prevData => {

            //copy previous data
            const newData = [...prevData];
      
            //copy data for current job link, overwrite previous IsActive property with new value
            newData[rowIndex] = {
              ...newData[rowIndex],
              IsActive
            };
            return newData;
          });

          hideLoading()


    }

    //fetch links on page load
    useEffect(() => {
        fetchJobLinks()
    }, [])

    return (

        <>
            
            {jobLinks.length > 0 ? 
            (
                <EditableTable 
                    data={jobLinks}
                    setData={setJobLinks}
                    schema={JobLinksSchema}
                    handleToggleAPI={handleActivateJobLink}
                />

            ) : null }

        </>

    )
}